import { Fragment } from 'react';
// Import Helpers
import { genericMemo } from 'services/Helpers';
// Import Components
import KeyValueItem, { type KeyValueItemProps } from 'components/common/KeyValueItem';

export type KeyValueItemsItemData<T extends boolean = false> = Omit<KeyValueItemProps<T>, 'vertical'> & {
    ItemWrapper?: React.ElementType;
};

export interface KeyValueItemsProps<T extends boolean = false> {
    items: KeyValueItemsItemData<T>[];
    vertical?: KeyValueItemProps<T>['vertical'];
}

const KeyValueItems = <T extends boolean = false>({ items, vertical }: KeyValueItemsProps<T>) => {
    return (
        <div className="crm-keyvalue-items-wrapper">
            {items.map(({ ItemWrapper = Fragment, ...rest }, index) => (
                <ItemWrapper key={index}>
                    <KeyValueItem vertical={vertical} {...rest} />
                </ItemWrapper>
            ))}
        </div>
    );
};

export default genericMemo(KeyValueItems);
